import * as Sentry from '@sentry/browser';

Sentry.init({
    dsn: "https://d49dc45eade54f90091c098c9995dbfc@o316041.ingest.us.sentry.io/4508975509667840",
    sendDefaultPii: true,
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
        Sentry.consoleLoggingIntegration({ levels: ["log", "error", "warn"] }),
    ],
    tracesSampleRate: 0.1,
    tracePropagationTargets: [],
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,

})
